module.exports = __webpack_public_path__ + "img/Group 427320696@2x.501dd1bc.png";